import { render } from "./EnvironmentModal.vue?vue&type=template&id=1bec38a4&scoped=true"
import script from "./EnvironmentModal.vue?vue&type=script&lang=js"
export * from "./EnvironmentModal.vue?vue&type=script&lang=js"

import "./EnvironmentModal.vue?vue&type=style&index=0&id=1bec38a4&scoped=true&lang=scss"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bec38a4"]])

export default __exports__